export const home = {
  searchPlaceholder: "ابحث برقم اللوحة",
  scanPlate: "التقاط لوحة السيارة",
  manualEntry: "إدخال رقم اللوحة يدوياً",
  cameraAccess: "تفعيل الكاميرا",
  searchHistory: "سجل البحث",
  freeSearches: "البحثات المجانية المتبقية",
  upgradeAccount: "ترقية الحساب",
  scanDescription: "استخدم الكاميرا لالتقاط صورة لوحة السيارة",
  manualDescription: "أدخل رقم اللوحة يدوياً للبحث",
  recentSearches: "اخر السجلات",
  noRecentSearches: "لا توجد بحثات سابقة"
};